import { useDispatch, useSelector } from 'react-redux'
import CustomButton, { IconButton } from '../../components/CustomButton'
import React, { useEffect, useState } from 'react'
import CustomModal from '../../components/CustomModal'
import TextArea from 'components/form/TextArea'
import { v4 as uuidv4 } from 'uuid'
import { OutlinedButton } from 'components/CustomButton'
import FormGroupWrapper from 'components/form/FormGroupWrapper'
import ProductCard from 'pages/dynamicUi/elements/products/ProductCard'
import { tryAddFaq, tryCreateFaq } from 'redux/slices/faqSlice'
import { isEmpty } from 'lodash'
import {
  addDoc,
  collection,
  doc,
  getDoc,
  onSnapshot,
  setDoc,
  updateDoc,
} from '@firebase/firestore'
import db from 'db/firebase'
import { FIREBASE_COLLECTION, SUB_COLLECTION } from './constant'
import TextEditor from 'components/form/textEditor/TextEditor'

const AddFaqForm = ({ showModal = false, setShowModal }) => {
  // const { faq: Faq } = useSelector((state) => state.faq)
  const dispatch = useDispatch()
  const payload = {
    question: '',
    answer: '',
  }
  const [faq, setFaq] = useState([
    {
      ...payload,
    },
  ])

  // useEffect(() => {
  // }, [Faq])

  const addNewFaq = () => {
    setFaq((prev) => [...prev, payload])
  }

  const removeFaq = (index) => {
    setFaq(faq.filter((_, i) => i !== index))
  }

  const onChange = (k, v, index) => {
    setFaq((prev) =>
      prev.map((p, n) => {
        return n === index ? { ...p, [k]: v } : p
      }),
    )
  }

  const submit = async () => {
    var faqDoc = doc(
      db,
      FIREBASE_COLLECTION,
      process.env.REACT_APP_ACTIVE_ENVIRONMENT,
    )
    var faqRef = collection(faqDoc, SUB_COLLECTION)
    const nestedDocRef = doc(faqRef, showModal?.product_id)

    const productFaq = await getDoc(nestedDocRef)

    if (!productFaq.data()) {
      await setDoc(nestedDocRef, {
        product_id: showModal?.product_id.toString(),
        faq: faq.map((f) => ({ ...f, id: uuidv4() })),
      })
    } else {
      await updateDoc(nestedDocRef, {
        faq: [
          ...productFaq.data().faq,
          ...faq.map((f) => ({ ...f, id: uuidv4() })),
        ],
      })
    }
    setShowModal()
    setFaq([{ ...payload }])
  }

  function isValid() {
    for (let item of faq) {
      if (isEmpty(item['question']) || isEmpty(item['answer'])) {
        return true
      }
    }
  }

  const Form = () => {
    return (
      <div className='flex items-start flex-row space-x-4 web'>
        {!!showModal && (
          <div className="sticky top-0">
            <ProductCard mobile={false} product={showModal} />
          </div>
        )}
        <div className="w-full">
          {faq.map((f, index) => (
            <FormGroupWrapper className="relative mb-0" hasTitle={false}>
              {faq.length > 1 && (
                <div className="absolute top-2 right-2">
                  <IconButton
                    onClick={() => {
                      removeFaq(index)
                    }}
                  />
                </div>
              )}
              <div className="flex flex-col">
                <TextArea
                  type="text"
                  color="blue"
                  rows="2"
                  placeholder="Question"
                  value={f['question']}
                  onChange={(e) => {
                    onChange('question', e, index)
                  }}
                />

                <TextEditor
                  label="Answer"
                  onChange={(e) => {
                    onChange('answer', e, index)
                  }}
                  value={f['answer']}
                />
              </div>
            </FormGroupWrapper>
          ))}
          <div className="flex justify-end">
            <OutlinedButton onClick={() => addNewFaq()}>+ Add Another FAQ</OutlinedButton>
          </div>
        </div>        
        </div> 
    )
  }

  return (
    <>
      <CustomModal
        title="Add FAQ"
        showModal={!!showModal}
        setShowModal={() => {
          setShowModal(false)
        }}
        loading={false}
        children={Form()}
        button={
          <CustomButton disabled={isValid()} onClick={() => submit()}>
            Add
          </CustomButton>
        }
      />
    </>
  )
}

export default AddFaqForm
